import React, { useState } from "react";
import {
    Card,
    CardContent,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableRow,
    Grid,
    Box,
} from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';

const simulacao = {
    CLT: {
        Salário: "10.000,00",
        INSS: "951,63",
        IRRF: "1.656,85",
        "Total Imposto": "2.608,48",
        Líquido: "7.391,52",
    },
    Autônomo: {
        Rendimento: "10.000,00",
        INSS: "951,63",
        IRPF: "1.579,57",
        "ISS (5%)": "500,00",
        "Total Imposto": "3.031,20",
        Líquido: "6.968,80",
        "Carga Tributária": "30,31%",
    },
    "PJ SN": {
        Receita: "10.000,00",
        INSS: "308,00",
        IRRF: "-",
        DAS: "600,00",
        "Total Imposto": "908,00",
        Líquido: "9.092,00",
        "Carga Tributária": "9,08%",
    },
};

const Tabela = ({ titulo, dados, color }) => (
    <Card
        sx={{
            borderRadius: 3,
            boxShadow: 4,
            background: `linear-gradient(145deg, ${color}, #0b243d)`,
            color: "white",
            height: "300px"
        }}
    >
        <CardContent>
            <Typography
                variant="h6"
                align="center"
                gutterBottom
                sx={{ fontWeight: "bold" }}
            >
                {titulo}
            </Typography>
            <Table size="small">
                <TableBody>
                    {Object.entries(dados).map(([chave, valor]) => (
                        <TableRow key={chave}>
                            <TableCell
                                sx={{
                                    color: "white",
                                    fontWeight: chave === "Líquido" ? "bold" : 600,
                                }}
                            >
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    {chave}
                                    {chave === "Líquido" && (
                                        <ArrowForwardIcon sx={{ color: "#1EFF86", fontSize: 18 }} />
                                    )}
                                </Box>
                            </TableCell>
                            <TableCell
                                align="right"
                                sx={{
                                    color: "white",
                                    fontWeight: chave === "Líquido" ? "bold" : "normal",
                                }}
                            >
                                {valor}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </CardContent>
    </Card>
);

export default function SimulacaoImpostos() {
    const colors = ["#233344", "#233344", "#233344"];

    const [valor, setValor] = useState("");

    const handleValueChange = (e) => {
        const inputValue = e.target.value;
        const numericValue = inputValue.replace(/\D/g, '');
        simulacao.CLT.Salário = numericValue;
        setValor(numericValue.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
    };

    const handleCalc = () => {
        let formattedValue = valor.replaceAll('.', '').replace(',', '.');

        const salario = parseFloat(formattedValue);
        let inssClt = 0;
        let irrfClt = 0;

        if (salario > 0 && salario <= 1518) {
            console.log("primeira faixa");
            inssClt = salario * 0.075;
        } else if (salario > 1518 && salario <= 2793.88) {
            console.log("segunda faixa");
            inssClt = (salario * 0.09) - 22.77;
        } else if (salario > 2793.88 && salario <= 4190.83) {
            console.log("terceira faixa");
            inssClt = (salario * 0.12) - 106.59;
        } else if (salario > 4190.83) {
            console.log("quarta faixa");
            inssClt = (salario * 0.14) - 190.40;
        }

        simulacao.CLT.INSS = inssClt.toFixed(2).replace('.', ',');
    }

    return (
        <Box sx={{ p: 4 }}>
            <Typography
                variant="h4"
                align="center"
                gutterBottom
                sx={{ fontWeight: "bold", mb: 4 }}
            >
                Simulação de Impostos - CLT x Autônomo x PJ
            </Typography>

            {/* <div
                style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "12px",
                    flexWrap: "wrap",
                    marginBottom: "32px",
                }}
            >
                <FormControl
                    fullWidth
                    sx={{
                        maxWidth: "420px",
                        flex: 1,
                    }}
                    variant="outlined"
                >
                    <InputLabel htmlFor="outlined-adornment-amount">
                        Valor
                    </InputLabel>

                    <OutlinedInput
                        id="outlined-adornment-amount"
                        startAdornment={
                            <InputAdornment position="start">R$</InputAdornment>
                        }
                        label="Valor"
                        placeholder="Informe o valor"
                        value={valor}
                        onChange={handleValueChange}
                        sx={{
                            minWidth: "300px",
                            fontWeight: 600,
                        }}
                    />
                </FormControl>

                <Button
                    variant="contained"
                    sx={{
                        height: "56px",
                        minWidth: "160px",
                        backgroundColor: "#9C01B9",
                        borderRadius: "16px 0 16px 0",
                        fontSize: "0.75rem",
                        color: "white",
                        fontWeight: 800,
                        textTransform: "uppercase",
                        transition: "0.3s ease",
                        whiteSpace: "nowrap",
                        '&:hover': {
                            backgroundColor: "#1EFF86",
                            color: "#000",
                            boxShadow: "0 6px 14px rgba(30, 255, 134, 0.6)",
                        },
                    }}
                    onClick={handleCalc}
                >
                    Simular agora
                </Button>
            </div> */}


            <Grid container spacing={3} justifyContent="center" alignItems="flex-start">
                {Object.entries(simulacao).map(([titulo, dados], idx) => (
                    <Grid key={titulo}>
                        <Tabela titulo={titulo} dados={dados} color={colors[idx]} />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
